import React from 'react';
import './LoadingPage.css';

export default function LoadingPage() {
  return (
    <div className="loading-container">
      {/* Removed old spinner and loading text */}
      <div className="modern-loading-overlay">
        <div className="modern-loader-icon"></div>
        <span className="modern-loader-text">Carregando...</span>
      </div>
    </div>
  );
}
